import { useMemo } from 'react';
import { useBlueberrySizeReport } from '../../../../services/data/reports/hooks/useBlueberrySizeReport';
import { useGetBlocksByVariety } from '../../../../services/entities/hooks/useGetBlocksByVariety';
import { StrictDateRange } from '../../../commonUI/DateRangeFilterSelect/types';
import {
  TableColumnDefinitions,
  useLoadTable,
} from '../../../duckDB/hooks/useLoadTable';
import { formatStringList } from '../../../duckDB/utils/formatStringList';

export const useLoadVarietySizeReport = (
  customerId: string | undefined,
  varietyId: string | undefined,
  dateRange: StrictDateRange | null
): boolean => {
  const { blocks, isBlocksLoading, isBlocksFetching } = useGetBlocksByVariety(
    customerId,
    varietyId
  );

  const blockIds = useMemo(() => {
    return formatStringList(blocks?.map((block) => block.id) || []);
  }, [blocks]);

  const { blueberrySizeReportData: response, isBlueberrySizeReportLoading } =
    useBlueberrySizeReport(customerId, dateRange ?? undefined);

  const data = useMemo(
    () => response?.filter((item) => blockIds.includes(item.block_id)) || [],
    [response, blockIds]
  );

  const { isTableLoading } = useLoadTable('size_report_table', data, {
    columns: SIZE_REPORT_COLUMN_DEFS,
  });

  return (
    isTableLoading ||
    isBlueberrySizeReportLoading ||
    isBlocksLoading ||
    isBlocksFetching
  );
};

const SIZE_REPORT_COLUMN_DEFS: TableColumnDefinitions = {
  block_id: 'VARCHAR',
  block_name: 'VARCHAR',
  ranch_id: 'VARCHAR',
  scan_date: 'TIMESTAMP_S',
  scan_id: 'VARCHAR',
  size_deduplicated_counts: 'VARCHAR',
};
